(function () {
  const LOG = false;

  function initLBMM() {
    const body = document.body;
    const toggle = document.querySelector(".lb-mm-toggle");
    const drawer = document.getElementById("lb-mm-drawer");

    if (!toggle || !drawer) return false;

    // prevent double binding
    if (toggle.dataset.lbBound === "1") return true;
    toggle.dataset.lbBound = "1";

    if (LOG) console.log("[LB-MM] init");

    const closeEls = drawer.querySelectorAll("[data-lb-mm-close]");
    let scrollY = 0;

    function lockScroll() {
      scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      body.style.top = `-${scrollY}px`;
      body.classList.add("lb-mm-open");
    }

    function unlockScroll() {
      body.classList.remove("lb-mm-open");
      body.style.top = "";
      window.scrollTo(0, scrollY);
    }

    function openMenu() {
      lockScroll();
      toggle.setAttribute("aria-expanded", "true");
      drawer.setAttribute("aria-hidden", "false");
    }

    function closeMenu() {
      unlockScroll();
      toggle.setAttribute("aria-expanded", "false");
      drawer.setAttribute("aria-hidden", "true");
    }

    function toggleMenu() {
      body.classList.contains("lb-mm-open") ? closeMenu() : openMenu();
    }

    toggle.addEventListener("click", toggleMenu);
    closeEls.forEach((el) => el.addEventListener("click", closeMenu));

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeMenu();
    });

    // (optional) overlay click
    drawer.addEventListener("click", (e) => {
      if (e.target && e.target.matches("[data-lb-mm-overlay]")) closeMenu();
    });

    // =========================
    // Tabs
    // =========================
    const tabs = Array.from(drawer.querySelectorAll("[data-lb-mm-tab]"));
    const panels = Array.from(drawer.querySelectorAll("[data-lb-mm-panel]"));

    function closeAllSubmenus() {
      drawer.querySelectorAll("[data-lb-mm-expander][aria-expanded='true']").forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        const sub = btn.nextElementSibling;
        if (sub && sub.classList.contains("lb-mm-sublist")) sub.setAttribute("hidden", "");
      });
    }

    function scrollPanelTop(panelEl) {
      // لو عندك container قابل للسكرول داخل الدروار
      // عدّل السلكتور ده حسب الـ HTML عندك
      const scroller =
        panelEl.querySelector(".lb-mm-panel-scroll") ||
        drawer.querySelector(".lb-mm-body") ||
        drawer;
      try {
        scroller.scrollTo({ top: 0, behavior: "auto" });
      } catch (_) {
        scroller.scrollTop = 0;
      }
    }

    function activateTab(name) {
      tabs.forEach((btn) => {
        const active = btn.getAttribute("data-lb-mm-tab") === name;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
      });

      let activePanel = null;

      panels.forEach((panel) => {
        const active = panel.getAttribute("data-lb-mm-panel") === name;
        panel.classList.toggle("is-active", active);
        if (active) {
          panel.removeAttribute("hidden");
          activePanel = panel;
        } else {
          panel.setAttribute("hidden", "");
        }
      });

      // UX: اقفل أي submenus مفتوحة + رجّع السكرول فوق
      closeAllSubmenus();
      if (activePanel) scrollPanelTop(activePanel);
    }

    if (tabs.length && panels.length) {
      tabs.forEach((btn) => {
        btn.addEventListener("click", () => {
          const name = btn.getAttribute("data-lb-mm-tab");
          activateTab(name);
        });
      });
    }

    // =========================
    // Accordion (Option B)
    // =========================
    drawer.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-lb-mm-expander]");
      if (!btn) return;

      // لازم sublist تكون next sibling
      const sub = btn.nextElementSibling;
      if (!sub || !sub.classList.contains("lb-mm-sublist")) {
        if (LOG) console.warn("[LB-MM] sublist not found next to expander");
        return;
      }

      const isOpen = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", isOpen ? "false" : "true");

      if (isOpen) sub.setAttribute("hidden", "");
      else sub.removeAttribute("hidden");
    });

    // لو عايز أول تاب يبقى شغال افتراضيًا لو مفيش is-active
    if (tabs.length && panels.length && !tabs.some(t => t.classList.contains("is-active"))) {
      activateTab(tabs[0].getAttribute("data-lb-mm-tab"));
    }

    return true;
  }

  document.addEventListener("DOMContentLoaded", () => initLBMM());
  document.addEventListener("shopify:section:load", () => initLBMM());
  setTimeout(() => initLBMM(), 50);
  setTimeout(() => initLBMM(), 250);

  const obs = new MutationObserver(() => {
    if (initLBMM()) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
